import { RequiredFieldTooltip } from '@/shared/components/required-field-tooltip';
import { Field, Select } from '@noorden-insurtech/alba-design-system';
import type { TFieldContext } from '../types';

export type SelectFieldOption = {
  value: string;
  label: string;
};

export type SelectFieldProps = {
  label: string;
  placeholder?: string;
  required?: boolean;
  options: SelectFieldOption[];
  disabled?: boolean;
  onValueChange?: (value: string) => void;
};

export function createSelectField(useFieldContext: () => unknown) {
  return function SelectField({
    label,
    placeholder,
    required,
    options,
    disabled,
    onValueChange,
  }: SelectFieldProps) {
    const field = useFieldContext() as TFieldContext<string>;

    return (
      <RequiredFieldTooltip active={required}>
        <Field.Root invalid={!!field.state.meta.errors.length}>
          <Field.Label>
            {label}
            {required && <span className='text-alba-error-red-500'>*</span>}
          </Field.Label>
          <Select.Root
          value={field.state.value ? [field.state.value] : []}
          onValueChange={details => {
            const nextValue = details.value[0] || '';
            field.handleChange(nextValue);
            onValueChange?.(nextValue);
          }}
          onFocusOutside={field.handleBlur}
          positioning={{ sameWidth: true }}
          items={options}
          disabled={disabled}
        >
          <Select.Control>
            <Select.Trigger className='min-w-0'>
              <Select.ValueText
                placeholder={placeholder || 'Selecione'}
                className='min-w-0 truncate'
              />
              <Select.Indicator />
            </Select.Trigger>
          </Select.Control>
          <Select.Positioner>
            <Select.Content>
              {options.map(option => (
                <Select.Item key={option.value} item={option}>
                  <Select.ItemText>{option.label}</Select.ItemText>
                  <Select.ItemIndicator />
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Positioner>
        </Select.Root>
          {field.state.meta.errors.length > 0 && (
            <Field.ErrorText>{field.state.meta.errors[0]}</Field.ErrorText>
          )}
        </Field.Root>
      </RequiredFieldTooltip>
    );
  };
}
